
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardStep1Controller from './project-donation-wizard.step1.controller';
import ProjectDonationWizardStep1Template from './project-donation-wizard.step1.html';

export default class ProjectDonationWizardStep1Component {
		constructor() {
				this.templateUrl = ProjectDonationWizardStep1Template;
				this.controller = ProjectDonationWizardStep1Controller;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					donation: '<',
					profile: '='
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step1/project-donation-wizard.step1.component.js